import GOOGLE_FONTS from './googleFonts.json';

const hostedFamilies = new Set(GOOGLE_FONTS.map((f) => f.family));
const loadedByDocument = new WeakMap();

const slug = (family) => family.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const familyFromValue = (value) => {
    if (!value) return null;
    const first = value.split(',')[0].trim();
    return first.replace(/^['"]|['"]$/g, '');
};

export const familiesInHtml = (html) => {
    if (!html) return [];
    const families = new Set();
    for (const match of html.matchAll(/font-family\s*:\s*((?:&quot;|&#39;|[^;"}>])+)/gi)) {
        const family = familyFromValue(match[1].replace(/&quot;/g, '"').replace(/&#39;/g, "'"));
        if (family) families.add(family);
    }
    return [...families];
};

export const loadGoogleFonts = (families, doc = document) => {
    if (!doc?.head) return;
    if (!loadedByDocument.has(doc)) loadedByDocument.set(doc, new Set());
    const loadedFamilies = loadedByDocument.get(doc);
    families.filter(Boolean).forEach((family) => {
        if (loadedFamilies.has(family) || !hostedFamilies.has(family)) return;
        loadedFamilies.add(family);
        const link = doc.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${window.location.origin}/fonts/google/${slug(family)}.css`;
        doc.head.appendChild(link);
    });
};

export const loadGoogleFont = (family) => loadGoogleFonts([family]);

export const loadGoogleFontsInHtml = (html, doc = document) => loadGoogleFonts(familiesInHtml(html), doc);
